module.exports = __webpack_public_path__ + "img/hold-asset-01.3300e0d1.jpg";